module.exports = __webpack_public_path__ + "img/icon-egame-active.d510586.webp";